import { resolveUrl } from "@/lib/img";

const aspectClass = {
  square: "aspect-square",
  portrait: "aspect-[3/4]",
  landscape: "aspect-[4/3]",
  wide: "aspect-[16/9]",
};

// Reusable image that always looks good regardless of source dimensions.
// Supports either a legacy `focal` keyword (center/top/...) or an interactive
// `position` ("x% y%") + `zoom` from the drag-to-frame adjuster.
export const SmartImage = ({ src, aspect = "landscape", fit = "cover", focal = "center", position, zoom, alt = "", className = "", testid }) => {
  const resolved = resolveUrl(src);
  if (!resolved) return null;

  if (aspect === "auto") {
    return (
      <img
        src={resolved}
        alt={alt}
        loading="lazy"
        className={`w-full h-auto rounded-2xl object-contain shadow-md ${className}`}
        data-testid={testid}
      />
    );
  }

  const hasPos = position != null && position !== "";
  const imgStyle = hasPos
    ? { objectFit: fit, objectPosition: position, transform: `scale(${zoom || 1})`, transformOrigin: position }
    : { objectFit: fit, objectPosition: focal };

  return (
    <div
      className={`relative overflow-hidden rounded-2xl bg-[var(--surface)] shadow-md ${aspectClass[aspect] || aspectClass.landscape} ${className}`}
      data-testid={testid}
    >
      <img
        src={resolved}
        alt={alt}
        loading="lazy"
        className="absolute inset-0 w-full h-full"
        style={imgStyle}
      />
    </div>
  );
};
